var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("path", {
    attrs: {
      d:
        "M16.73,7.31H6l4.4-4.44a1.3,1.3,0,0,0,0-1.81L9.77.45A1.23,1.23,0,0,0,8,.48L.37,8.1a1.33,1.33,0,0,0,0,1.84L7.9,17.46a1.36,1.36,0,0,0,1.87.13l.6-.61a1.3,1.3,0,0,0,0-1.81L6,10.73H16.73A1.27,1.27,0,0,0,18,9.45V8.59A1.28,1.28,0,0,0,16.73,7.31Z"
    }
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1c58725a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1c58725a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/assets/icons/WayfinderArrowLeft.vue
// module id = null
// module chunks = 